<template>
  <div class="product-page">
    <h1>Abandoned Checkouts</h1>
    <Abandon />
  </div>
</template>

<script>
import Abandon from './components/Abandon';

export default {
  components: { Abandon },
};
</script>
